import { render, staticRenderFns } from "./SortPair.vue?vue&type=template&id=750aae29&scoped=true"
import script from "./SortPair.vue?vue&type=script&lang=js"
export * from "./SortPair.vue?vue&type=script&lang=js"
import style0 from "./SortPair.vue?vue&type=style&index=0&id=750aae29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750aae29",
  null
  
)

export default component.exports